import React, { useEffect, useRef } from "react";
import Me from "../../img/me.png";
import { motion, useAnimation, useInView } from "framer-motion";

function About() {
  const ref = useRef(null);
  const isINView = useInView(ref, { once: false });
  const mainControls = useAnimation();

  useEffect(() => {
    if (isINView) {
      mainControls.start("visible");
    }
  }, [isINView]);
  return (
    <div
      id="about"
      className="flex sm:h-screen py-[100px] sm:py-0 items-center justify-center "
      ref={ref}
    >
      <motion.div className="w-[80vw] sm:w-[60vw]">
        <h1 className="title">
          <span>01.</span>About Me
        </h1>
        <div className="section">
          {/* <div
            initial={{ y: "-1000px" }}
            animate={{ y: "0px" }}
            className="right"
          >
            <img src={Me} alt="img" />
          </div> */}
          <div className="left">
            <motion.p
              animate={mainControls}
              initial="hidden"
              variants={{
                hidden: { opacity: 0, y: 75 },
                visible: {
                  opacity: 1,
                  y: 0,
                },
              }}
              transition={{ delay: 0.5, duration: 0.5 }}
              className="desc"
            >
              I'm Abhishek, a frontend web developer with 2 years of experience
              crafting engaging and dynamic web experiences. My expertise spans
              modern technologies like HTML, CSS, and JavaScript, with a focus
              on creating visually stunning and user-friendly websites.
              <br></br>
              <p>
                In my journey, I've honed my skills in React.js and Next.js,
                building efficient and scalable web applications. Additionally,
                I leverage the power of Framer Motion to bring delightful
                animations to life, enhancing the interactivity and appeal of my
                projects.
              </p>
              <br />
              <p>
                I am dedicated to continuous learning and staying at the
                forefront of web development trends and best practices, ensuring
                that my work is both innovative and cutting-edge. Let's bring
                creative ideas to life and make the web a more beautiful place
                together!
              </p>
            </motion.p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default About;
